module.exports = __webpack_public_path__ + "static/media/cx.a4343636.svg";